import ActionButton from '@/components/bundles/share/grid/tasksListGrid/ActionButtonLink'

export default {
  computed: {
    gridColumns () {
      const isAppraisal = (field) => field ? 'appraisal' : 'main'
      const setupClassesOnRow = (row, meta) => {
        meta.settings.aoData[meta.row].nTr.classList = `${isAppraisal(row.parentId)}`
      }

      return [
        {
            id: 0,
            data: 'DT_RowId',
            searchable: false,
            orderable: false,
            render: (data, type, row) => {
              return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
            }
          },
          {
            id: 1,
            title: 'NR CRLS',
            data: 'taskNumber',
            render: (data, type, row, meta) => {
              setupClassesOnRow(row, meta)
              return data !== null ? data : row.id
            }
          },
          { id: 2, data: 'assignee', title: 'OPIEKUN', sortable: false },
          { id: 3, data: 'state', title: 'STATUS' },
          {
            id: 4,
            data: 'createdAt',
            title: 'UTWORZONO',
            render: (data) => {
              return this.formatDate(data)
            }
          },
          { id: 5, data: 'orderId', title: 'NR BANKU' },
          { id: 6, data: 'address', title: 'ADRES' },
          { id: 7, data: 'localVisionAppointedAt', title: 'DATA WIZJI' },
          { id: 8, data: 'landRegisterNumber', title: 'NR KW' },
          { id: 9, data: 'voivodeship', title: 'WOJEWÓDZTWO' },
          { id: 10, data: 'analyst', title: 'ANALITYK' },
          { id: 11, data: 'orderCompletionAt', title: 'TERMIN REALIZACJI' },
          { id: 12, data: 'closedAt', title: 'PIERWSZE PRZEKAZANIE' },
          { id: 13, data: 'customerFullname', title: 'DANE KLIENTA' },
        ]
    }
  }
}
